import { call }         from 'ramda'
import { load }         from 'recaptcha-v3'
import { useEffect }    from 'react'
import { useState }     from 'react'

// export default useRecaptcha

const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY

/**
 * @return Null | ((Undefined | String) -> Promise String)
 */
const useRecaptcha = () => {

    const [execute, setExecute] = useState (null)

    const onMount = () => void call (async () => {

        const recaptcha = await load (recaptchaKey)

        void setExecute (() => recaptcha.execute.bind (recaptcha))

    })

    void useEffect (onMount, [])

    return execute

}

export default useRecaptcha
